import Layout from 'features/shared/Layout';
import Community from 'features/pages/Community';

export default function Page() {
  return (
    <Layout
      description="Talk to others taking the challenges, get help with your code, discuss features. Chat about everything front-end!"
      image="https://res.cloudinary.com/dz209s6jk/image/upload/v1585172856/Meta/meta-homepage.png"
      title="Frontend Mentor | Join the Frontend Mentor community"
      url="https://www.frontendmentor.io/community"
    >
      <Community />
    </Layout>
  );
}

export async function getStaticProps() {
  return { props: {} };
}
